import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledSkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 0;
  background: ${props => props.theme.colors.primary};
  color: white;
  padding: 8px;
  z-index: 9999;
  transition: top 0.3s;

  &:focus {
    top: 0;
  }
`;

const SkipLink: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledSkipLink href="#main-content">
      {t("common:skipToContent", "Skip to main content")}
    </StyledSkipLink>
  );
};

export default SkipLink;
